module.exports = __webpack_public_path__ + "static/img/fish50.57e01b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish50.png
// module id = jIuT
// module chunks = 0